import { Typography } from '@material-ui/core'
import { useEffect } from 'react'
import { useTranslate } from 'react-admin'
import FileWithContext from '../../../models/file_with_context'
import { darkGrey } from '../../../pages/ExtranetTickets/utils'
import UpsertFileButton from '../../file_upload'

const ImageInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  setRefresh,
  setErrors,
  errors,
  previews,
  ...props
}) => {
  const translate = useTranslate()
  useEffect(() => {
    setPayload({ ...payload, [source]: getImagesInterventions(record, true) })
  }, [record])

  const getImagesInterventions = (data, onlyUrl = false) => {
    return data.fwc.pics_intervention.map((item) => (onlyUrl ? item.url : item))
  }

  return (
    <>
      <UpsertFileButton
        acceptOnly={'image/*'}
        previewAttachedFiles={previews}
        labelButton={translate(label, { _: label })}
        height="100px"
        copro_id={record?.copro_id}
        resource="file_with_context"
        documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        validTypes={[FileWithContext.TYPE.INTERVENTION_PHOTO]}
        validCategories={[FileWithContext.CATEGORY.TECHNICAL]}
        linkable_id={record.ticket_id}
        linkable_type="tickets"
        upload_by={record.token_id_internal}
        upload_by_type="prestataires"
        expectProvider={true}
        defaultValue={
          record.fwc.pics_intervention ? getImagesInterventions(record) : []
        }
        readOnly={false}
        saveResult={({ accepted_files }) => {
          if (accepted_files) {
            setRefresh(() => {
              return new Date().getTime()
            })
          }
        }}
      />
    </>
  )
}
export default ImageInput
